import React, { Component } from 'react';
import { Label, Row, Col, Input, Table } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';

class InvestorLog extends Component {
    constructor(props) {
        super(props);
        const url = this.props.selector != null ? this.props.selector.split('/') : [];

        this.state = {
            investor: (url[1] != null && url[1] !== '') ? decodeURIComponent(url[1]).replace(/\//g, '-') : '',
            fund: (url[2] != null && url[2] !== '') ? decodeURIComponent(url[2]).replace(/\//g, '-') : '',
            investors: [],
            funds: [],
            data: [],
            sheetData: [],
            clientList: this.props.filterClients(),
            filter: {},
            sort: '',
            sortType: 'text',
            sortAsc: true,
            headers: [
                { display: 'Investor', accessors: ['investor'], filter: true },
                { display: 'Fund', accessors: ['fund'], filter: true },
                { display: 'Transaction Type', accessors: ['type'], filter: true },
                { display: 'Date', accessors: ['date'], type: 'date', filter: true, classNames: 'text-center' },
                { display: 'Amount', accessors: ['amount'], type: 'currency', classNames: 'text-right' },
            ]
        };
    }

    componentDidMount() {
        this.props.log('InvestorLog.js/componentDidMount');
        this.getInvestors(); this.getFunds(); this.onSubmit();
        this.props.filterClientsCallback(() => {
            this.setState({
                clientList: this.props.filterClients()
            })
        });
        this.props.passHeaders(this.state.headers, this.callback);
    }

    callback = (headers) => {
        this.props.log('InvestorLog.js/callback (headers)', headers);
        this.setState({
            headers: headers
        }, () => this.getCSVdata());
    }

    getFormattedDate = (date) => {
        this.props.info('InvestorLog.js/getFormattedDate (date)', date);
        let year = date.getFullYear()//.toString().substr(2, 2);
        let month = (1 + date.getMonth())/*.toString().padStart(2, '0')*/;
        let day = date.getDate()/*.toString().padStart(2, '0')*/;
        return month + '/' + day + '/' + year;
    }

    getFormattedField = (val, type) => {
        this.props.info('InvestorLog.js/getFormattedField (val,type)', val, type);
        if (val == null || val === '') return val;
        switch (type) {
            case "date":
                return this.getFormattedDate(new Date(val.substr(0, 4), parseInt(val.substr(5, 2)) - 1, val.substr(8, 2)));
            case "datetime":
                return this.getFormattedDate(new Date(val.substr(0, 4), parseInt(val.substr(5, 2)) - 1, val.substr(8, 2))) + ' ' + this.formatAMPM(new Date(val));
            case "number":
                return Intl.NumberFormat().format(parseFloat(val));
            case "currency":
                return new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                }).format(val);
            default:
                return val;
        }
    }

    getInvestors = () => {
        this.props.log('InvestorLog.js/getInvestors');
        fetch('/api/reports/InvestorListings', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-DB': this.props.clientId
            },
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        investors: results.data.map(item => { return (item.data != null && item.data.companyName != null) ? item.data.companyName : null })
                    });
                } else {
                    this.props.addToast('Unable to get investors.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getFunds = () => {
        this.props.log('InvestorLog.js/getFunds');
        fetch('/api/reports/FundListings', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-DB': this.props.clientId
            },
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        funds: results.data.map(item => { return (item.data != null && item.data.fundName != null) ? item.data.fundName : null })
                    });
                } else {
                    this.props.addToast('Unable to get funds.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onSubmit = () => {
        this.props.log('InvestorLog.js/onSubmit');
        fetch('/api/reports/InvestorLog', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-DB': this.props.clientId
            },
            body: JSON.stringify([
                { key: 'investor', type: 'nvarchar', value: this.state.investor !== '' ? this.state.investor : null },
                { key: 'fund', type: 'nvarchar', value: this.state.fund !== '' ? this.state.fund : null },
            ])
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        data: this.prepareData(results.data)
                    }, () => this.getCSVdata());
                } else {
                    this.props.addToast('Unable to download report.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    prepareData = (data) => {
        this.props.log('InvestorLog.js/prepareData');
        return data.map(row => {
            let obj = {};
            obj.data = row;
            return obj;
        });
    }

    replaceSpecialChars = (str) => {
        this.props.info('InvestorLog.js/replaceSpecialChars (str)', str)
        if (str == null) return '';
        return str.split('/').map(segment => {
            return segment.normalize('NFD').replace(/[\u0300-\u036f]/g, '') // Remove accents
                .replaceAll('%2F', '-')
                .replace(/\//g, '-')
                .replaceAll('%20', ' ')
                .replace(/([^\w]+|\s+)/g, '-') // Replace space and other characters by hyphen
                .replace(/--+/g, '-')	// Replaces multiple hyphens by one hyphen
                .replace(/(^-+|-+$)/, ''); // Remove extra hyphens from beginning or end of the string
        }).join('/').toLowerCase();
    }

    getCSVdata = () => {
        this.props.log('InvestorLog.js/getCSVdata');
        if (this.state.data.length === 0 /*|| parseInt(this.state.fund) === 0 || this.state.fund === ''*/) {
            this.props.passData([], '');
        } else {
            const retArr = [
                ['Investor', 'Fund'],
                [
                this.state.investor,
                this.state.fund
                ],
                []
            ].concat([
                this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).map((header) => (
                    header.display
                ))
            ]).concat(
                this.state.data.map(row => {
                    let retArray = [];
                    // this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).forEach((header, headerIndex) => {
                    //     retArray[headerIndex] = row.data[header.accessors[0]];
                    // });
                    return retArray;
                })
            );
            this.props.passData(retArr, "pe-fund-transactions-analysis" /*+ name*/);
        }
    }

    onChange = (e) => {
        this.props.log('InvestorLog.js/onChange (name, value, e)', e.target.name, e.target.value, e);
        e.persist();
        let value = '/';
        let refresh = true;
        this.setState((prevState) => {
            let sel = prevState;
            sel[e.target.name] = (e.target.value);
            value += ((sel.investor) === '' ? '' : encodeURIComponent(sel.investor)) + '/' + ((sel.fund) === '' ? '' : encodeURIComponent(sel.fund));
            if (e.target.name === 'investor' && e.target.value === '0') {
                sel.investor = '';
                value = ((sel.fund !== '') ? '//' + sel.fund : '/');
            }
            if (e.target.name === 'fund' && e.target.value === '0') {
                sel.fund = '';
                value = ((sel.investor !== '') ? sel.investor + '/' : '/');
            }
            this.props.changeSelector({ target: { name: '', value: value.replace(/[/]+$/, '') } });
            return sel;
        }, () => {
            if (refresh) {
                this.onSubmit();
            }
            this.getCSVdata();
        });
    }

    onChangeFilter = (e) => {
        this.props.log('InvestorLog.js/onChangeFilter (e)', e.target.name, e.target.value);
        e.persist();
        this.setState((prevState) => {
            let sel = prevState;
            sel.filter[e.target.name] = e.target.value;
            return sel;
        })
    }

    render() {
        this.props.info('InvestorLog.js/render');
        return (
            <>
                <Row className="mb-4 noPrint">
                    <Col md={3} className="px-2">
                        <Label className='w-100'>Investor
                            <Input type="select" className="companySelect w-100" name="investor" value={this.props.replaceSpecialChars(this.props.isFieldNull(this.state.investor).replace(/\//g, '-'))} onChange={this.onChange}>
                                <option value="0">Show All</option>
                                {this.state.investors.map(investor => (
                                    <option key={investor} value={this.props.replaceSpecialChars(this.props.isFieldNull(investor).replace(/\//g, '-'))}>{investor}</option>
                                ))}
                            </Input>
                        </Label>
                    </Col>
                    <Col md={3} className="px-2">
                        <Label className='w-100'>Fund
                            <Input type="select" className="companySelect w-100" name="fund" value={this.props.replaceSpecialChars(this.props.isFieldNull(this.state.fund).replace(/\//g, '-'))} onChange={this.onChange}>
                                <option value="0">Show All</option>
                                {this.state.funds.map(fund => (
                                    <option key={fund} value={this.props.replaceSpecialChars(this.props.isFieldNull(fund).replace(/\//g, '-'))}>{fund}</option>
                                ))}
                            </Input>
                        </Label>
                    </Col>
                </Row>
                {this.state.data.length > 0 ?
                    <Table>
                        <thead>
                            <tr>
                                {this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).map((header, headerIndex) => (
                                    <th className={header.classNames}
                                        // className='pointer'
                                        // onClick={() => this.setState(this.props.setSort(header.accessors[0], header.type, this.state.sort, this.state.sortAsc, header.dbField))}
                                        key={"sort" + headerIndex}>
                                        {header.display}
                                        {/* {header.accessors[0] === this.state.sort ? <span className="sortChevron">
                                            <FontAwesomeIcon icon={this.state.sortAsc ? faChevronUp : faChevronDown} />
                                        </span> : null} */}
                                    </th>
                                ))}
                            </tr>
                            <tr>
                                {this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).map((header, headerIndex) => (
                                    <th key={"filter" + headerIndex}>
                                        {header.filter ? <Input
                                            type="text"
                                            name={header.accessors[0]}
                                            placeholder={"Filter " + header.display}
                                            onClick={(e) => e.stopPropagation()}
                                            onChange={this.onChangeFilter}
                                            value={header.accessors[0] != null && this.state.filter[header.accessors[0]] != null ? this.state.filter[header.accessors[0]] : ''}
                                        /> : null}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.props.orderEntries(this.state.data, { uniqueId: this.state.sort, asc: this.state.sortAsc, type: this.state.sortType }, false).filter(entry => {
                                    let temp = true;
                                    Object.keys(this.state.filter).forEach(field => {
                                        if ((entry.data[field] != null && this.state.filter[field] != null &&
                                            (entry.data[field].toUpperCase().indexOf(this.state.filter[field].toUpperCase()) === -1)) ||
                                            ((this.state.filter[field] != null && this.state.filter[field] !== '') && entry.data[field] == null)) temp = false;
                                    })
                                    return temp;
                                })
                                    .map((row, rowIndex) => (
                                        <tr key={"data" + rowIndex} className="pointer" onClick={() => {
                                            window.location.pathname = (
                                                '/company/' +
                                                this.replaceSpecialChars(row.data.form) +
                                                '/' + row.data.formEntryId) +
                                                '/' + (row.data.investor) +
                                                '/' + (row.data.fund)
                                        }}>
                                            {this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).map((header, headerIndex) => (
                                                <td className={header.classNames} key={"header" + headerIndex}>
                                                    {this.getFormattedField(row.data[header.accessors[0]], header.type)}
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                        </tbody>
                    </Table>
                    : <>No results</>}
            </>
        );

    }
}

export default InvestorLog;
